import React, { useEffect, useReducer } from "react";

import Html from "./html";
import { loadMessages } from "./service";
import Reducer from "./reducer";
import Context from "./context";
import { initialState } from "./initialState";
import FormSubmit from "./components/formSubmit";
import ChatClosedWithRefundBtn from "./components/chatClosedWithRefundBtn";
import CardWithHeaderTemplate from "../../../components/cardWithHeaderTemplate";
import OffcanvasTemplate from "../../../components/offcanvasTemplate";
import { disputesRef } from "../../../firebase";

const Chat = ({
    show,
    dispute,
    handleClose,
    is_inbox,
    header, 
    emptyChat,
    is_have_selected_dispute
}) => {
    const [state, dispatch] = useReducer(Reducer, initialState);

    useEffect(() => {
        let messagesUnsubscribe;
        let disputeUnsubscribe;

        const fetchData = async () => {
            if (dispute) {
                messagesUnsubscribe = await loadMessages(dispute, dispatch);
            }
        };
        
        fetchData();

        disputeUnsubscribe = disputesRef.doc(dispute?.doc_id).onSnapshot((snapshot) => {
            const data = snapshot.data();
            dispatch({
                type: "DISPUTE_IS_RESOLVED",
                dispute_is_resolved: data?.dispute_is_resolved,
            });
        });

        return () => {
            if (messagesUnsubscribe) {
                messagesUnsubscribe();
            }
            if (disputeUnsubscribe) {
                disputeUnsubscribe();
            }
        };
    }, [dispute]);

    if(is_inbox){
        return (
            <Context.Provider value={{dispute, state, dispatch}}>
                <CardWithHeaderTemplate
                    header={header} 
                    body={is_have_selected_dispute ? <Html/> : emptyChat} 
                    footer= {
                        is_have_selected_dispute && (
                            <div className="card-footer d-block">
                                {/* <FormSubmit/> */}
                                {(state.dispute_is_resolved) ? (
                                    <ChatClosedWithRefundBtn />
                                ) : (
                                    <FormSubmit/>
                                )}
                            </div>
                        )
                    }
                    extraCardClassName = {`blur shadow-blur max-height-vh-70 h-fix-100`}
                    extraBodyClassName = {`overflow-auto overflow-x-hidden`}
                />
            </Context.Provider>
        );
    }else{
        return(
            <Context.Provider value={{dispute, state, dispatch}}>
                <OffcanvasTemplate
                    open={show} 
                    handleClose = {() => handleClose()} 
                    placement = {'end'}  
                    title = {`DISPUTE : ${dispute?.dispute_details?.type}`}
                    body = {<Html/>} 
                    footer = {
                        <div className="container">
                            <div className="row" style={{marginTop: '10px'}}>
                                <div className="col">
                                    <div className="d-grid gap-2 mb-3" >
                                        {(state.dispute_is_resolved) ? (
                                            <ChatClosedWithRefundBtn />
                                        ) : (
                                            <FormSubmit/>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                />
            </Context.Provider>
        )
    }
}

export default Chat;